import { createAction } from '@reduxjs/toolkit'
import { call, ForkEffect, put, select, takeEvery } from 'redux-saga/effects'

import { FlagFilters } from '../../../models/flags'
import { isFlagVisibleBasedOnFilters } from '../../../shared/services/flags/flags-service'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Flag, Workspace } from '../../lib/toolBoxes/2D'
import { selectFlagFilters } from '../../slices/materialFlags'
import { setFlagsVisibility } from '../../slices/tools'

export const toggleMaterialFlagsVisibilityAction = createAction<boolean>('toggleMaterialFlagsVisibility')

export function* handleToggleMaterialFlagsVisibility({
    payload: isMaterialFlagsVisible,
}: ReturnType<typeof toggleMaterialFlagsVisibilityAction>) {
    const paperManager: PaperManager | null = yield call(managers.get2DManager)

    if (!paperManager) return

    const workspaceTool: Workspace = yield call(paperManager.getTool, Workspace.NAME)

    const materialFlagsItems: paper.Item[] = yield call(
        workspaceTool.getItemsWithCriteria,
        'data',
        (data) => data.toolName === Flag.NAME
    )

    const flagFilters: FlagFilters = yield select(selectFlagFilters)

    materialFlagsItems.forEach((materialFlag) => {
        const { type, status, jiraStatusId, categoryId, createdByEmail, isTemporaryGroup } = materialFlag.data

        const passesFilter = isFlagVisibleBasedOnFilters(
            flagFilters,
            type,
            status,
            jiraStatusId,
            categoryId,
            createdByEmail
        )

        materialFlag.visible = isMaterialFlagsVisible && (isTemporaryGroup || passesFilter)
    })

    yield put(setFlagsVisibility(isMaterialFlagsVisible))
}

export function* watchForToggleMaterialFlagsVisibility(): Generator<ForkEffect<never>, void, unknown> {
    yield takeEvery(toggleMaterialFlagsVisibilityAction.type, handleToggleMaterialFlagsVisibility)
}
